import React from "react";

const ReunionDashboardFooter = () => {
  return (
    <footer className="mt-12 bg-gradient-to-b from-[#08211b] via-[#061814] to-black border-t border-emerald-500/10">
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="grid lg:grid-cols-12 gap-8">
          {/* Left */}

          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="text-3xl">🫂</span>

              <div>
                <h2 className="text-2xl font-black text-white">Reunion</h2>

                <p className="text-xs tracking-[0.25em] uppercase text-emerald-300">
                  Think5Whys • PurpleDoor
                </p>
              </div>
            </div>

            <p className="text-sm text-emerald-100 leading-7">
              Reunion transforms every gathering into an engaging, memorable and
              interactive experience. Whether it is a family function, school
              reunion, corporate meeting, birthday celebration or community
              event, Reunion keeps everyone connected through fun, participation
              and celebration.
            </p>

            <div className="mt-5 text-xs text-emerald-400">
              © 2026 Think5Whys Global DeepTech Solutions Pvt. Ltd. All Rights
              Reserved.
            </div>
          </div>

          {/* Middle */}

          <div className="lg:col-span-3">
            <h3 className="uppercase tracking-[0.30em] text-sm text-emerald-300 mb-5">
              Dashboard
            </h3>

            <div className="space-y-3 text-sm text-emerald-100">
              <div>⚙️ Display Settings</div>

              <div>▶️ Start Reunion</div>

              <div>📊 Live Feed</div>

              <div>⏹️ Stop Reunion</div>

              <div>🏆 Winners Ceremony</div>
            </div>
          </div>

          {/* Right */}

          <div className="lg:col-span-4">
            <h3 className="uppercase tracking-[0.30em] text-sm text-emerald-300 mb-5">
              Reunion Vision
            </h3>

            <h4 className="text-xl font-black leading-snug mb-4">
              Every Gathering
              <br />
              Deserves a Memory.
            </h4>

            <p className="text-sm text-emerald-100 leading-7">
              From classrooms to conferences, housing societies to hometown
              reunions, Reunion brings people together with live interaction,
              joyful competition and unforgettable celebrations.
            </p>

            <div className="mt-6 rounded-2xl border border-emerald-500/20 bg-emerald-500/10 px-5 py-4 text-center">
              <div className="text-2xl mb-2">🫂✨🏆🎊</div>

              <div className="font-bold text-emerald-200">
                Meet • Play • Celebrate • Remember
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ReunionDashboardFooter;
